import React from 'lib/react';
import {
  EVGrid, EVPaper, EVTypography,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import accessDeniedPageStyles from './accessDeniedPageStyles';

function AccessDeniedPage() {
  const { t } = useTranslation();
  const classes = accessDeniedPageStyles();
  return (
    <EVGrid className={classes.pageNotFoundPage}>
      <EVPaper className={classes.pageNotFoundPageContainer}>
        <EVPaper elevation={0} className={classes.pageNotFoundPageItemsContainer}>
          <EVPaper elevation={0}>
            <EVTypography className={classes.pageNotFound}>{t('access_denied__text')}</EVTypography>
            <EVTypography className={classes.statusMessage}>{t('access_denied__message')}</EVTypography>
          </EVPaper>
        </EVPaper>
      </EVPaper>
    </EVGrid>
  );
}

export default AccessDeniedPage;
